<template>
  <div id="app">
    <rare-website-header
      :navigationOpen="navigationOpen"
      :showNavigation="showNavigation"
      @openNavigation="openNavigation"
    />

    <router-view
      @hideNavigation="hideNavigationFunc"
      @showNavigation="showNavigationFunc"
      @openContactForm="openContactForm"
      @openStoriesModal="openStoriesModal"
      @closeStoriesModal="closeStoriesModal"
    />

    <rare-footer/>

    <rare-navigation-modal
      v-if="navigationOpen"
      @closeNavigation="closeNavigation"
    />

    <rare-contact-modal
      v-if="contactFormOpen"
      @closeContactForm="closeContactForm"
    />

    <rare-cookie-banner-new
      v-show="showCookiePanel"
      @rejectCookies="rejectCookies"
      @acceptCookies="acceptCookies"
    />

  </div>
</template>

<script>
import cookieDelete from '../static/cookieDelete';

import Header from './components/header/Header';
import RareFooter from './components/commonSections/RareFooter';

import NavigationModal from './components/header/navigationModal';
import RareContactModal from './components/forms/RareContactModal';
import RareCookieBannerNew from './components/commonSections/RareCookieBannerNew';

// import { GoogleAnalyticsCode } from './assets/env';

export default {
  name: 'App',
  data() {
    return {
      showNavigation: true,
      navigationOpen: false,
      contactFormOpen: false,
      manageCookiesOpen: false,
      storiesOpen: false,
      oldYPos: 0,
    };
  },
  components: {
    'rare-website-header': Header,
    'rare-footer': RareFooter,
    'rare-navigation-modal': NavigationModal,
    'rare-contact-modal': RareContactModal,
    'rare-cookie-banner-new': RareCookieBannerNew,
  },
  computed: {
    showCookiePanel() {
      return this.$store.getters.showCookiePanel;
    },
    recordPageView() {
      return !this.$store.getters.showCookiePanel;
    },
  },
  methods: {
    logPageView(currentPage) {
      // console.log('logPageView()');
      if (this.recordPageView === true) {
        window.gtag('event', 'page_view', {
          page_title: document.title,
          page_location: window.location.href,
          page_path: currentPage,
        });
        return true;
      }
      return false;
    },
    closeNavigation() {
      this.navigationOpen = false;
    },
    openNavigation() {
      this.navigationOpen = true;
    },
    closeContactForm() {
      window.scrollTo(0, this.oldYPos);
      this.contactFormOpen = false;
    },
    openContactForm() {
      this.contactFormOpen = true;
      this.oldYPos = window.scrollY;
      window.scrollTo(0, 0);
    },
    openStoriesModal() {
      this.storiesOpen = true;
    },
    closeStoriesModal() {
      this.storiesOpen = false;
    },
    showNavigationFunc() {
      this.showNavigation = true;
    },
    hideNavigationFunc() {
      this.showNavigation = false;
    },
    acceptCookies() {
      this.$store.commit('updateCookiesAccepted', true);
      this.$store.commit('updateShowCookiePanel', false);

      // Hubspot import
      const plugin = document.createElement('script');
      plugin.setAttribute(
        'src',
        '//js-eu1.hs-scripts.com/27067983.js',
      );
      plugin.async = true;
      document.head.appendChild(plugin);

      const fullPath = window.location.pathname;
      const currentPage = `${window.location.origin}${fullPath}`;

      window.gtag('event', 'page_view', {
        page_title: document.title,
        page_location: currentPage,
        page_path: fullPath,
      });
    },
    rejectCookies() {
      this.$store.commit('updateCookiesAccepted', false);
      this.$store.commit('updateShowCookiePanel', false);
    },
  },
  watch: {
    $route(to, from) {
      // console.log(to);
      // this.logPageView(to.fullPath);
      // This bit watches for the route changing while the stories modal is open.
      // If that does occur we know the back button has been pressed. In which case we don't want to go back,
      // instead we want to close the modal. This was a request from Raph.
      if (from.name === 'Stories' && this.storiesOpen === true) {
        this.storiesOpen = false;
        window.history.forward(1);
      }
      this.oldYPos = 0;
      this.closeNavigation();
      this.closeContactForm();
    },
  },
  mounted() {
    if (!this.$cookies.isKey('rareWebSiteAcceptCookies')) {
      cookieDelete();
      this.$store.commit('updateShowCookiePanel', true);
    } else {
      // eslint-disable-next-line
      if (this.$cookies.get('rareWebSiteAcceptCookies') === 'true') {
        this.$store.commit('updateShowCookiePanel', true);
      } else {
        this.$store.commit('updateShowCookiePanel', false);
        // this.logPageView(window.location.pathname);
      }
    }

    document.title = this.$route.meta.title;
    Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));
    this.$route.meta.metaTags.map((tagDef) => {
      const tag = document.createElement('meta');
      Object.keys(tagDef).forEach((key) => {
        tag.setAttribute(key, tagDef[key]);
      });
      tag.setAttribute('data-vue-router-controlled', '');
      return tag;
    }).forEach(tag => document.head.appendChild(tag));

    this.$root.$on('updateContactForm', (openOrClose) => {
      if (openOrClose === true) {
        this.openContactForm();
      } else if (openOrClose === false) {
        this.closeContactForm();
      }
    });
  },
};
</script>

<style lang="css">

@import "css/app.css";

</style>



// WEBPACK FOOTER //
// src/App.vue